import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="w-full bg-primary-600 px-4 py-12 md:px-8 md:py-16 lg:px-12">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left">
        <div className="max-w-2xl">
          <h2 className="font-heading text-2xl font-bold leading-tight text-background-50 md:text-3xl">
            下次再遇到看不懂的瓜，先来这里
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-primary-100 md:text-base">
            时间线、证据清单、双方说法一次看完，不用在零散信息里来回拼凑。
          </p>
        </div>
        <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
          <Link
            to="/topics"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-accent-100"
          >
            浏览全部复盘
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            提供材料线索
          </Link>
        </div>
      </div>
    </section>
  );
}